import { render, staticRenderFns } from "./chat-audio-to-text-xunfei.vue?vue&type=template&id=31302c48&scoped=true"
import script from "./chat-audio-to-text-xunfei.vue?vue&type=script&lang=js"
export * from "./chat-audio-to-text-xunfei.vue?vue&type=script&lang=js"
import style0 from "./chat-audio-to-text-xunfei.vue?vue&type=style&index=0&id=31302c48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31302c48",
  null
  
)

export default component.exports